/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CheckPhoneResponseDto = {
    /**
     * What the web flow should do next for this number
     */
    status: CheckPhoneResponseDto.status;
};
export namespace CheckPhoneResponseDto {
    /**
     * What the web flow should do next for this number
     */
    export enum status {
        NEW = 'new',
        RESUMABLE = 'resumable',
        EXPERT_COMPLETE = 'expert_complete',
        CLIENT_CONFLICT = 'client_conflict',
    }
}

